import React from 'react';
import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { SECURITY_PATH } from '../../constants';
import { formatPhone } from '../common/helper';

export const useAccountButton = 'sms-account-modal-button';
export const accountPhoneModal = 'sms-account-phone-modal';

function AccountPhoneModal({ phoneNumber, handleClose, handleContinue }) {

  return (
    <Modal open onClose={handleClose} aria-label={accountPhoneModal}>
      <ModalHeader onClose={handleClose}>Use Account Phone Number?</ModalHeader>
      <ModalBody>
        <div className="sui-grid sui-gap-4">
          <Typography variant="body-base">
            {`We found a phone number on your account and text messages will be sent to this phone number.
              To edit your phone number, please visit the `}
            <Link href={SECURITY_PATH}>Security</Link>
            {' page before continuing to sign up for text messages.'}
          </Typography>
          <div className="sui-text-center">
            <Typography variant="body-base" weight="bold">
              {formatPhone(phoneNumber)}
            </Typography>
          </div>
        </div>
      </ModalBody>
      <ModalFooter position="end">
        <Button aria-label={useAccountButton} onClick={handleContinue}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
}

AccountPhoneModal.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired

};

export default AccountPhoneModal;
